import { render, staticRenderFns } from "./VividDiamond.vue?vue&type=template&id=4853d230&scoped=true&"
import script from "./VividDiamond.vue?vue&type=script&lang=js&"
export * from "./VividDiamond.vue?vue&type=script&lang=js&"
import style0 from "./VividDiamond.vue?vue&type=style&index=0&id=4853d230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853d230",
  null
  
)

export default component.exports